import type React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FormProvider } from 'react-hook-form';
import type { RelatedDealParam } from '~/models/DealForm';
import type { Deal } from '~/models/Deal';
import { buildDealParam, relatedDealValidationSchema } from '~/models/DealForm';
import { DealEditorBody } from './DealEditorBody';
import { DealEditorFooter } from './DealEditorFooter';

type Props = {
  deal: Deal;
};

export const DealEditor: React.FC<Props> = ({ deal }) => {
  const methods = useForm<RelatedDealParam>({
    mode: 'onBlur',
    resolver: yupResolver(relatedDealValidationSchema),
    shouldFocusError: false,
    defaultValues: buildDealParam({
      inspectionBy: 'none',
      dealType: null,
      leasingId: null
    })
  });
  return (
    <div>
      <FormProvider {...methods}>
        <DealEditorBody deal={deal} />
        <DealEditorFooter deal={deal} />
      </FormProvider>
    </div>
  );
};
